export default __webpack_public_path__ + "static/media/Logout.efa514e9.svg";